import {
  Wrench,
  Zap,
  Paintbrush2,
  Home,
  Trees,
  Car,
  Hammer,
  ShowerHead,
  Wind,
  Shield,
  Drill,
  Scissors
} from 'lucide-react';

export const availableServices = [
  {
    id: 1,
    name: 'Plumbing',
    icon: ShowerHead,
    category: 'Maintenance',
    description: 'Professional plumbing services'
  },
  {
    id: 2,
    name: 'Electrical',
    icon: Zap,
    category: 'Installation',
    description: 'Electrical installation and repair services'
  },
  {
    id: 3,
    name: 'Cleaning',
    icon: Scissors,
    category: 'Maintenance',
    description: 'Professional cleaning services'
  },
  {
    id: 10,
    name: 'Kitchen Renovation',
    icon: Home,
    category: 'Renovation',
    description: 'Complete kitchen renovation services'
  },
  {
    id: 11,
    name: 'Bathroom Renovation',
    icon: ShowerHead,
    category: 'Renovation',
    description: 'Complete bathroom renovation services'
  },
  {
    id: 12,
    name: 'Heating & Cooling',
    icon: Wind,
    category: 'Installation',
    description: 'HVAC installation and maintenance'
  },
  {
    id: 13,
    name: 'Landscaping',
    icon: Trees,
    category: 'Outdoor',
    description: 'Professional landscaping services'
  },
  {
    id: 14,
    name: 'Painting',
    icon: Paintbrush2,
    category: 'Renovation',
    description: 'Interior and exterior painting services'
  },
  {
    id: 15,
    name: 'Roofing',
    icon: Shield,
    category: 'Maintenance',
    description: 'Roofing repair and installation'
  },
  {
    id: 16,
    name: 'Flooring',
    icon: Drill,
    category: 'Renovation',
    description: 'Flooring installation and repair'
  },
  {
    id: 17,
    name: 'General Handyman',
    icon: Hammer,
    category: 'Maintenance',
    description: 'General handyman services'
  }
];

export const getServicesByCategory = () => {
  return availableServices.reduce((acc, service) => {
    if (!acc[service.category]) {
      acc[service.category] = [];
    }
    acc[service.category].push(service);
    return acc;
  }, {});
};